import { Form } from 'react-bootstrap';

export const CustomDropdown = ({
    setEntities,
    entities,
    label,
    defaultValue,
    disabled = false,
}: {
    setEntities: (entitie: string) => void;
    entities: { label: string; value: string }[];
    label: string;
    defaultValue?: string | number | readonly string[] | undefined;
    disabled?: boolean;
}) => {
    return (
        <>
            <h5 className='w-100 mb-0 py-3'>{label}</h5>
            <Form.Select
                {...{ disabled }}
                className='distributor-list'
                onChange={(e) => setEntities(e.target.value)}
                aria-label='Default select example'
                htmlSize={5}
                defaultValue={defaultValue}
            >
                {entities.map(({ value, label }, index) => (
                    <option
                        key={index}
                        className='px-2 py-1 rounded'
                        value={value}
                        onClick={() => {
                            setEntities(value);
                        }}
                    >
                        {label}
                    </option>
                ))}
            </Form.Select>
        </>
    );
};
